// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__6Gxuc","heroContainer":"Hero_heroContainer__RG4D_"};